/**
 * New Products  Functional Component
 * @Package - seo/brand
 * @Author - Manila@UPWA-Team
 * @description: New arrival related to brand SEO
 */

import React, { useContext } from 'react'
import { Heading3, NewProducts as CNewProducts } from '@usap/widgets'

import GetReviews from '../../../helpers/GetReviews'
import { LocalContext } from '../../../helpers/useLocalContext'
import { formatBrand } from "../../../transformers/BrandText";

export default function NewProducts(props) {
  const {
    dynamicApiData = {}, screenSize, isBot, apiDetails,
  } = props
  const brandName = apiDetails.props.brands
  const isDesktop = screenSize === 'large'
  const colWidth = isDesktop ? '16.66%' : '33.33%'

  const { header } = dynamicApiData
  const isBrandStore = brandName.includes(header)
  const newProducts = dynamicApiData.products && dynamicApiData.products.newProducts
  const hasNewProducts = Array.isArray(newProducts) && newProducts.length > 0

  const render = dynamicApiData.products && hasNewProducts && isBrandStore

  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const title = `${dynamicApiData.header} New Arrivals`

  return render && (
    <CNewProducts
      id="NewProducts"
      isDesktop={isDesktop}
      records={dynamicApiData.products.newProducts}
      title={title}
      limit={9}
      colWidth={colWidth}
      Link={Link}
      bgColor="white"
      getReviews={GetReviews}
      Heading={Heading3}
      headingStyle={null}
      isBot={isBot}
      formatBrand={formatBrand}
    />
  )
}
